import { Badge, Form } from "antd";

// Компонент для метки с бейджем
const FormLabel = ({ label, name, required }) => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            position: "relative",
            paddingBottom: 16, // место под бейдж
        }}
    >
        <div style={{ display: "flex", alignItems: "center" }}>
            <span>{label}</span>
            {required && (
                <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>
            )}
        </div>
        {name && (
            <Badge
                count={name}
                color="#BFBFBF"
                size="small"
                style={{ fontWeight: "normal" }}
            />
        )}
    </div>
);

// Компонент формы с горизонтальной компоновкой
const HorizontalFormItem = ({ label, name, children, rules, disabled }) => {
    const isRequired = rules && rules.some(rule => rule.required);

    return (
        <Form.Item
            label={<FormLabel label={label} name={name} required={isRequired} />}
            name={name}
            rules={rules}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            labelAlign="left"
            colon={false}
            required={false} // отключаем автоматическую звездочку Ant Design
        >
            {typeof children === "function" ? children({ disabled }) : children}
        </Form.Item>
    );
};

export default HorizontalFormItem;